/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./action-setting.vue?vue&type=template&id=39792e90&"
import script from "./action-setting.vue?vue&type=script&lang=ts&"
export * from "./action-setting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports